import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {downgradeComponent} from '@angular/upgrade/static';
import * as angular from 'angular';
import {UserService} from '../../shared/user.service';
import {Employee} from 'resteasytox';
import 'rxjs/add/operator/take';
import {Subject} from 'rxjs/Subject';
import {ApiService} from '../../api/api.service';
import {EmployeeType} from '../../settings/settings-employees/settings-employees.component';
import {CookieService} from 'ngx-cookie';
import {ReportsService} from 'app/reports/reports.service';

import {
	HOLIDAYS_WEEKENDS_CHECK_SERVICE,
	HolidaysWeekendsCheckService
} from '../../shared/upgrade/holidays-weekends-check-service.service';

import {LOCATION_SERVICE} from '../../shared/upgrade/location.service';
import {
	PAYMENT_FREQUENCY, PaymentFrequency, TimecardBuilderService, TimecardPeriod, TtTimecard,
	VIEW_DATE_FORMAT
} from '../timecards-builder.service';
import {Moment} from 'moment';
import * as moment_ from 'moment';
import {DateRange, extendMoment} from 'moment-range';
import * as _ from 'lodash';
import {PeriodPickerComponent} from '../period-selector/period-selector.component';
import {
	EmployeeEditHistoryDetails,
	EmployeesEditHistoryCacheService
} from '../../core/employee-edit-history-cache.service';

const moment: any = extendMoment(moment_);

import {forkJoin} from 'rxjs/observable/forkJoin';
import {EmployeeFilterComponent} from '../../shared/employee-filter/employee-filter.component';

export interface TimecardsCookieState {
	user: any;
	employees: number[];
	paymentFrequency: PaymentFrequency;
	endDate: string;
	startDate: string;
}

export interface TimecardRow {
	nonDownloaded: boolean;
	non_billable: number;
	billable: number;
	ah_hours: number;
}

@Component({
	selector: 'tt-timecards',
	templateUrl: './timecards.component.html',
	styleUrls: ['./timecards.component.scss']
})
export class TimecardsComponent implements OnInit, OnDestroy {
	@Input('employees') employees: Employee[];
	public readonly EMPLOYEE_TYPE: any = EmployeeType;
	public userDataLoaded: boolean = false;
	public data: any = false;
	public today: Date = new Date();

	public loader: boolean = false;
	public daysOff: any[] = [];
	public overriddenTimecardRows: any[] = [];
	public submittedTimecards: any[] = [];
	public displayedRanges: any = {
		'bi-weekly': {},
		'monthly': {}
	};
	public reportEmail: string;
	public currentUserDetails: EmployeeEditHistoryDetails;

	public stateCookieName: string = 'timecardsState';
	public employeesFilterStateCookieName: string = 'selectedTimecardsEmployeesNG2';
	private destroy$: Subject<void> = new Subject<void>();

	public isWeekend: Function = this.holidaysWeekendsCheckServiceNg1.isWeekend;
	public isHoliday: Function = this.holidaysWeekendsCheckServiceNg1.isHoliday;

	@ViewChild(EmployeeFilterComponent)
	private employeeFilterComponent: EmployeeFilterComponent;

	@ViewChild(PeriodPickerComponent)
	private periodPickerComponent: PeriodPickerComponent;

	private employeeFilterInited: boolean = false;
	private periodPickerInited: boolean = false;

	public calculateTimecardTotalDays: Function = this.timecardBuilderService.calculateTimecardTotalDays;

	public calculateTimecardTotalHours: Function = this.timecardBuilderService.calculateTimecardTotalHours;


	constructor(
		private userService: UserService,
		private apiService: ApiService,
		private cookieService: CookieService,
		private reportsService: ReportsService,
		private timecardBuilderService: TimecardBuilderService,
		private employeesEditHistoryCacheService: EmployeesEditHistoryCacheService,
		@Inject(HOLIDAYS_WEEKENDS_CHECK_SERVICE) private holidaysWeekendsCheckServiceNg1: HolidaysWeekendsCheckService,
		@Inject(LOCATION_SERVICE) private locationServiceNg1: angular.ILocationService
	) {

	}

	public ngOnInit(): void {
		this.employees = _.orderBy(this.employees, ['firstName']);
		this.onInit(this.userService.user);
	}

	public ngOnDestroy(): void {

	}

	public isAdmin(): boolean {
		return this.userService.user && this.userService.user.admin;
	}

	public isQbAdmin(): boolean {
		return this.userService.user && this.userService.user.qbAdmin;
	}

	public updateReport(dates?: TimecardPeriod): void {
		if (dates === undefined) {
			dates = this.periodPickerComponent.getSelectedPeriod();
		}

		if (!dates) { this.hideLoader(); alert('Select date range in the right column'); return; }
		this.getReportData(dates);
	};

	public getReportData(dates: any[]): void {
		this.showLoader();
		let employees: number[] = [];
		if (this.userService.user && !this.userService.user.admin) {
			employees = [this.userService.user.id]; // non admin users can see only their own timecard
		} else {
			employees = this.employeeFilterComponent.getSelectedEmployeesIds();
		}

		const data: TimecardsCookieState = {
			startDate: dates[0],
			endDate: dates[1],
			employees: employees,
			paymentFrequency: this.periodPickerComponent.getSelectedPaymentFrequency(),
			user: this.userService.user
		};
		this.saveStateToCookie(data);

		if (!data['startDate'] || !data['endDate']) { this.hideLoader(); return; }
		// TODO: add join for multiple requests

		forkJoin(
			this.reportsService.getTimecards(data['startDate'], data['endDate'], data['employees']),
			this.reportsService.getSubmittedTimecards(data['startDate'], data['endDate'], data['employees']),
			this.apiService.getDaysOffDetailsForTheRange(data['startDate'], data['endDate'], data['employees']),
			this.reportsService.getTimecardRowsForRange(data['startDate'], data['endDate'], data['employees'])
		)
			.subscribe((res: any[]) => {
				const timecards: TtTimecard[] = res[0];
				const submittedTimecards: any = res[1];
				const daysOff: any[] = res[2];
				const overrriddenTimecardsRows: any[] = res[3];

				this.submittedTimecards = submittedTimecards;
				this.overriddenTimecardRows = this.formatOverriddenTimecardRows(overrriddenTimecardsRows);
				this.daysOff = this.formatDaysOffData(daysOff);
				this.addEmptyTimecards(timecards, data.startDate, data.endDate, employees);
				this.data = this.formatTimecardsData(timecards, submittedTimecards, this.overriddenTimecardRows, this.daysOff);
				this.hideLoader();
			}, (err: any) => {
				console.error(err);
				this.hideLoader();
			});
	};

	public getReportTitle(): string {
		return this.formatPeriodName(this.periodPickerComponent.getSelectedPeriod());
	}

	public getSelectedPaymentFrequency(): string {
		return this.periodPickerComponent.getSelectedPaymentFrequency();
	}

	// TODO: add type for data
	private formatTimecardsData(timecards: any[], submittedTimecards: any, overriddenRows: any, daysOff: any): any[] {
		let result: any[] = [];
		let employee: Employee;
		let employeeOverriddenRows: any = {};
		let employeeSubmittedTimecards: any = {};

		_.each(timecards, (emplData: any, emplId: string) => {
			employee = _.find(this.employees, {'id': parseInt(emplId, 10)});
			employeeOverriddenRows = _.pickBy(overriddenRows, (row: any, employeeId: string ) => {
				return employeeId === emplId;
			});
			employeeSubmittedTimecards = _.filter(submittedTimecards, (timecard: any) => {
				return timecard.employeeId.toString() ===  emplId.toString();
			});

			result = _.concat(result, this.timecardBuilderService.buildEmployeeTimecardsForPeriod(emplData.dates, employee, employeeOverriddenRows[emplId] || {}, employeeSubmittedTimecards, daysOff[emplId], emplData.nonDownloaded));
		});

		return _.sortBy(result, ['firstName']);
	}

	public onPeriodChanged(period: TimecardPeriod): void {
		this.updateReport(period);
		this.cookieService.put('selectedTimecardsRange', JSON.stringify({range: period[0], paymentFrequency: this.periodPickerComponent.getSelectedPaymentFrequency(), user: this.userService.user.loginName}), {
			expires: new Date(Date.now() + 60 * 60 * 1000)
		});
	};

	public onEmployeeFilterInited(): void {
		this.employeeFilterInited = true;
		if (this.periodPickerInited) {
			this.updateReport();
		}
	}

	public onPeriodPickerInited(): void {
		this.periodPickerInited = true;
		if (this.employeeFilterInited) {
			this.updateReport();
		}
	}

	public formatTimecardTableValue(value: string): string {
		return parseFloat(value).toFixed(2);
	}

	private formatDaysOffData(data: any): any {
		const result: any = {};
		_.each(data, (item: any) => {
			const emplId: number = item.id;
			if (result[emplId] === undefined) {
				result[emplId] = [];
			}
			result[emplId].push(item);
		});

		return result;
	}

	private formatOverriddenTimecardRows(data: any): any {
		const result: any = {};
		_.each(data, (row: any) => {
			if (result[row.employee] === undefined) {
				result[row.employee] = {};
			}

			result[row.employee][row.date] = row;
		});

		return result;
	}


	public formatPeriodName(range: TimecardPeriod): string {
		if (!range || range.length < 2) { return ''; }
		const sDate: Moment = moment(range[0], VIEW_DATE_FORMAT);
		const fDate: Moment = moment(range[1], VIEW_DATE_FORMAT);
		return `${sDate.format('YYYY MM-DD')} to ${fDate.format('MM-DD')}`;
	};

	public submitTransactionDetails (transactionId: string, timecardData: any, employeeID: string, billingUnitsTotal: number): void {
		const timecardId: number = timecardData.timecardId;
		const dates: string[] = _.map(timecardData.dates, (item: any) => {
			item['date'] = moment(item['date']).format('MM/DD/YYYY');
			return item;
		});
		const range: TimecardPeriod = this.periodPickerComponent.getSelectedPeriod();

		const data: any = {
			startDate: range[0],
			endDate: range[1],
			employeeId: employeeID,
			transactionId: transactionId,
			sequenceId: timecardData.sequenceId,
			dates: dates,
			billingUnitsTotal: billingUnitsTotal
		};
		if (timecardId !== undefined) {
			data['id'] = timecardId;
		}
		this.reportsService.submitTimecardTransactionDetails(timecardId, employeeID, transactionId, timecardData.sequenceId, range[0], range[1], dates, billingUnitsTotal)
			.map((response: any) => {
				alert('Timecard submitted successfully');
				timecardData.submitted = true;
				timecardData.submittedDate = moment(response.createdDate).format('MM/DD/YYYY');
				timecardData.transactionId = response.transactionId;
			})
			.subscribe(() => {
				console.log('subscribe');
			});
	};

	public submitTimecardToApproval(timecardData: any, employeeID: string, billingUnitsTotal: number): void {
		if (!confirm('If you submit timecard to approval, you cannot edit it anymore. Do you really want submit it?')) {
			return;
		}
		const range: TimecardPeriod = this.periodPickerComponent.getSelectedPeriod();
		this.reportsService.submitTimecardToApproval(employeeID, range[0], range[1], timecardData.sequenceId, billingUnitsTotal)
			.subscribe((response: any) => {
				alert('Timecard submitted to approval.');
				timecardData.waitApproval = true;
				timecardData.submittedDate = moment(response.createdDate).format('MM/DD/YYYY');
			});
	};

	public unsubmitUnapprovedTimecard(emplDetails: any): void {
		this.reportsService.unsubmitUnapprovedTimecard(emplDetails.timecardId)
			.subscribe((res: any) => {
				if (res.success && res.payload) {
					this.updateReport();
				}
			});
	}

	private showLoader(): void {
		this.loader = true;
	}

	private hideLoader(): void {
		this.loader = false;
	}

	public sendEmail (transactionId: string, employeeId: number, email: string): void {
		if (!email) {
			email = _.find(this.employees, {id: employeeId}).email;
		}
		if (!email) {
			alert('Person doesn\'t have email');
			return;
		}
		this.reportsService.submitTransactionEmailReport(transactionId, email)
			.subscribe(() => {
				alert('Report submitted successfully');
			});
	};

	public goToWorkingHoursReport(date: Date, employeeId: string): void {
		const d: string = moment(date).format('MM/DD/YYYY');
		const emplId: number = parseInt(employeeId, 10);
		const data: any = {
			startDate: d,
			endDate: d,
			employees: [emplId],
			showNonBillable: false,
			showBillableTime: false,
			showRegularTime: false,
			showAfterTime: false
		};
		this.cookieService.putObject('workingHoursState', data, {
			expires: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
		});

		this.locationServiceNg1.path('/workingHoursReport');
	};

	private saveStateToCookie(data: TimecardsCookieState): void {
		if (!data['paymentFrequency']) {
			data['paymentFrequency'] = this.periodPickerComponent.getSelectedPaymentFrequency();
		}
		data['user'] = this.userService.user.loginName;

		this.cookieService.putObject(this.stateCookieName, data, {
			expires: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
		});
	}

	// TODO: add proper types
	private getEmptyTimecard(startDate: string, endDate: string): any {
		const start: Moment = moment(startDate, 'MM/DD/YYYY');
		const end: Moment = moment(endDate, 'MM/DD/YYYY');
		const range: DateRange = moment.range(start, end);
		const timecard: any = {};
		const emptyRow: TimecardRow = {nonDownloaded: false, non_billable: 0, billable: 0, ah_hours: 0};
		const dates: Moment[] = Array.from(range.by('day'));

		for (const day of dates) {
			timecard[day.format('MM/DD/YYYY')] = JSON.parse(JSON.stringify(emptyRow));
		}

		return timecard;
	}
	private addEmptyTimecards(timecards: any[], startDate: string, endDate: string, employeesIds: number[]): void {
		_.each(employeesIds, (employeeId: number) => {
			if (!timecards[employeeId]) {
				timecards[employeeId] = {};
				timecards[employeeId]['dates'] = this.getEmptyTimecard(startDate, endDate);
				const employee: Employee = _.find(this.employees, { id: employeeId });
				if (!employee) { return; }
				timecards[employeeId]['employeeDetails'] = {
					firstName: employee.firstName,
					lastName: employee.lastName,
					startWork: employee.startWork,
					paymentFrequency: employee.paymentFrequency
				};
				timecards[employeeId]['nonDownloaded'] = false;
			}
		});
	}

	public employeeFilterChanged(employeesIds: number[]): void {
		// Обновлять report когда фильтр обновился
		this.updateReport();

	}

	public getTimecardTitle(data: any): string {
		if (data.submitted) {
			return 'Payment was submitted. You cannot edit this time card anymore.';
		}
	};

	public printTimecardRange(data: any): string {
		const f: any = _.first(data.dates);
		const t: any = _.last(data.dates);
		return this.formatPeriodName([ moment(f.date).format(VIEW_DATE_FORMAT), moment(t.date).format(VIEW_DATE_FORMAT) ]);
	}

	public isValidPaymentFrequency(timecard: any): boolean {
		// return true;
		// if (!employeeDetails.paymentFrequency) { return true; }
		return timecard.paymentFrequency === this.periodPickerComponent.getSelectedPaymentFrequency() || timecard.paymentFrequency === PAYMENT_FREQUENCY.NO_TIMECARD;
	};
	public editBillingUnits (item: any, submitted: boolean): void {
		if (submitted) { return; }
		item.billingUnitsNew = item.billingUnits;
		item.editMode = true;
	};

	public billingUnitsInputKeydown(event: KeyboardEvent, item: any): void {
		if (event.keyCode === 27) { // Escape
			this.closeEditBillingUnits(item);
		}
	};
	public closeEditBillingUnits(item: any): void {
		item.editMode = false;
	};
	public submitBillingUnits(item: any, emplID: number): void {
		this.reportsService.updateTimecardRowBillingUnits(emplID, moment(item.date).format('MM/DD/YYYY'), item.billingUnitsNew)
			.subscribe((response: any) => {
				if (response.success) {
					if (response.data.billingUnits !== undefined) {
						item.billingUnits = this.formatTimecardTableValue(response.data.billingUnits);
						item.overridden = true;
					} else {
						const date: string = moment(item.date).format(VIEW_DATE_FORMAT);
						const bu: any = this.timecardBuilderService.calculateBillableUnitsForDateEmployeeId(date, item, null, this.daysOff[this.userService.user.id], this.userService.user.id);
						item.billingUnits = this.formatTimecardTableValue(bu.value);
						item.overridden = false;
					}

					item.editMode = false;
				}
			});

	};

	public editNote(item: any, submitted: boolean): void {
		if (submitted) { return; }
		item.editNoteMode = true;
		item.noteNew = item.note;
	};

	public itemNoteInputKeydown(event: KeyboardEvent, item: any): void {
		if (event.keyCode === 27) { // Escape
			this.closeEditNote(item);
		}
	};

	public closeEditNote(item: any): void {
		item.editNoteMode = false;
	};

	public submitNote(item: any, emplID: number): void {
		this.reportsService.updateTimecardRowNote(emplID, moment(item.date).format('MM/DD/YYYY'), item.noteNew)
			.subscribe((response: any) => {
				if (response.success) {
					item.note = response.data.note;
					this.closeEditNote(item);
				}
			}, (err: any) => {
				alert('Technical Error. New note value was not stored database');
			});

	}

	private onInit(currentUser: Employee): void {
		this.showLoader();
		this.reportEmail = currentUser.email;

		const currentUserDetails: EmployeeEditHistoryDetails = this.employeesEditHistoryCacheService.getEmployeeDetailsAtDate(currentUser.id, moment().startOf('day').valueOf());
		if (!currentUserDetails) {
			alert('Unable to get user details for current date. Check if Person Pay Status History is filled correctly');
		} else {
			this.currentUserDetails = currentUserDetails;
		}

		this.userDataLoaded = true;
		this.hideLoader();
	}
}


angular.module('timetracker2')
	.directive(
		'ttTimecards',
		downgradeComponent({ component: TimecardsComponent }) as angular.IDirectiveFactory
	);



// WEBPACK FOOTER //
// ./src/app/reports/timecards/timecards.component.ts